import jsPDF from 'jspdf';
import moment from 'moment';
import { Base64 } from 'js-base64';
import { config } from './config';
import logo from './ISB-Dash.png'
import { getSettings } from './fetch';

// update sheet range since open office does a poor job of it
// it's useful when the files are saved from open office, or libre office
export function update_sheet_range(ws, XLSX) {
  var range = { s: { r: 20000000, c: 20000000 }, e: { r: 0, c: 0 } };
  Object.keys(ws).filter(function (x) { return x.charAt(0) != "!"; }).map(XLSX.utils.decode_cell).forEach(function (x) {
    range.s.c = Math.min(range.s.c, x.c); range.s.r = Math.min(range.s.r, x.r);
    range.e.c = Math.max(range.e.c, x.c); range.e.r = Math.max(range.e.r, x.r);
  });
  ws['!ref'] = XLSX.utils.encode_range(range);
}

export function sortStudents(sort) {
  return function (a, b) {
    // sort by lastname if there is no sort item
    //console.log(sort.item);
    //console.log(sort);
    //console.log(a);
    var itemA = a.lastName;
    var itemB = b.lastName;
    if (sort.item) {
      if (sort.item === "hrTeacher") {
        if (a.hrTeacher === ("None" || undefined)) {
          a.hrTeacher = a.advisor;
        }
        if (b.hrTeacher === ("None" || undefined)) {
          b.hrTeacher = b.advisor;
        }
      }
      //console.log(a);
      //console.log(a.maps[0].language.ritScore);
      //console.log(JSON.parse(sort.item));
      let items = sort.item.split(".");
      if (items.length === 1) {
        if (a[sort.item] != null)
          itemA = a[sort.item].toUpperCase();
        if (b[sort.item] != null)
          itemB = b[sort.item].toUpperCase();
      } else {
        if (items.length === 3) {
          if (a[items[0]] && a[items[0]][items[1]] && a[items[0]][items[1]][items[2]]) {
            itemA = a[items[0]][items[1]][items[2]];
          } else {
            itemA = null;
          }
          if (b[items[0]] && b[items[0]][items[1]] && b[items[0]][items[1]][items[2]]) {
            itemB = b[items[0]][items[1]][items[2]];
          } else {
            itemB = null;
          }
        } else if (items.length === 4) {
          if (a[items[0]] && a[items[0]][items[1]] && a[items[0]][items[1]][items[2]] && a[items[0]][items[1]][items[2]][items[3]]) {
            itemA = a[items[0]][items[1]][items[2]][items[3]];
          } else {
            itemA = null;
          }
          if (b[items[0]] && b[items[0]][items[1]] && b[items[0]][items[1]][items[2]] && b[items[0]][items[1]][items[2]][items[3]]) {
            itemB = b[items[0]][items[1]][items[2]][items[3]];
          } else {
            itemB = null;
          }
        } else if (items.length === 5) {
          if (a[items[0]] && a[items[0]][items[1]] && a[items[0]][items[1]][items[2]] && a[items[0]][items[1]][items[2]][items[3]] && a[items[0]][items[1]][items[2]][items[3]][items[4]]) {
            itemA = a[items[0]][items[1]][items[2]][items[3]][items[4]];
          } else {
            itemA = null;
          }
          if (b[items[0]] && b[items[0]][items[1]] && b[items[0]][items[1]][items[2]] && b[items[0]][items[1]][items[2]][items[3]] && b[items[0]][items[1]][items[2]][items[3]][items[4]]) {
            itemB = b[items[0]][items[1]][items[2]][items[3]][items[4]];
          } else {
            itemB = null;
          }
        }
      }

      if (sort.item === "lastName") {
        if (itemA.localeCompare(itemB) > 0) { return sort.asc ? -1 : 1; }
        if (itemA.localeCompare(itemB) < 0) { return sort.asc ? 1 : -1; }
      } else if (sort.item === "birthday") {
        //console.log('date A', itemA, new Date(itemA));
        //console.log('date B', itemB, new Date(itemB));
        if (new Date(itemA) > new Date(itemB)) { return sort.asc ? -1 : 1; }
        if (new Date(itemA) < new Date(itemB)) { return sort.asc ? 1 : -1; }
      } else {

        if (itemA > itemB) { return sort.asc ? -1 : 1; }
        if (itemA < itemB) { return sort.asc ? 1 : -1; }
        if (itemA === itemB)          // identical? return 0
          return 0;
        else if (itemA === null)  // a is null? last 
          return 1;
        else if (itemB === null)  // b is null? last
          return -1
      }
    }
    // names must be equal
    return 0;
  }
}

export function colorCodeMap(gradeWhenTaken, termName, testName, score, percentile, outputType) {
  // output type can be 'hex' or, default, 'name'
  // test name can be "math", "language" or "reading"
  var grade = null;
  var term = null;

  switch (gradeWhenTaken) {
    case "1":
      grade = "grade3";
      break;
    case "2":
      grade = "grade3";
      break;
    case "3":
      grade = "grade3";
      break;
    case "4":
      grade = "grade4";
      break;
    case "5":
      grade = "grade5";
      break;
    case "6":
    case "7":
    case "8":
    case "9":
    case "10":
    case "11":
    case "12":
      grade = "hsMs";
      break;
    default:
      grade = null;
      break;
  }

  if (termName.toLowerCase().indexOf("spring") !== -1) {
    term = "spring";
  } else {
    term = "fall";
  }

  var barColor = "none";

  var colorCodingRules = {
    grade3: {
      math: {
        fall: { red: 176, yellow: 177, green: 190, blue: 203 },
        spring: { red: 188, yellow: 189, green: 203, blue: 217 },
      },
      reading: {
        fall: { red: 171, yellow: 172, green: 188, blue: 204 },
        spring: { red: 184, yellow: 185, green: 199, blue: 214 },
      },
      language: {
        fall: { red: 173, yellow: 174, green: 189, blue: 204 },
        spring: { red: 185, yellow: 186, green: 200, blue: 214 },
      },
    },
    grade4: {
      math: {
        fall: { red: 187, yellow: 188, green: 202, blue: 216 },
        spring: { red: 198, yellow: 199, green: 214, blue: 229 },
      },
      reading: {
        fall: { red: 181, yellow: 182, green: 198, blue: 214 },
        spring: { red: 190, yellow: 191, green: 206, blue: 221 },
      },
      language: {
        fall: { red: 183, yellow: 184, green: 199, blue: 214 },
        spring: { red: 192, yellow: 193, green: 207, blue: 221 },
      },
    },
    grade5: {
      math: {
        fall: { red: 195, yellow: 196, green: 211, blue: 226 },
        spring: { red: 204, yellow: 205, green: 221, blue: 237 },
      },
      reading: {
        fall: { red: 190, yellow: 191, green: 206, blue: 221 },
        spring: { red: 196, yellow: 197, green: 212, blue: 227 },
      },
      language: {
        fall: { red: 190, yellow: 191, green: 206, blue: 220 },
        spring: { red: 197, yellow: 198, green: 211, blue: 224 },
      }
    }
  }

  if (grade === "hsMs") {
    if (percentile <= 20) barColor = "red";
    if (percentile > 20) barColor = "orange";
    if (percentile > 40) barColor = "yellow";
    if (percentile > 60) barColor = "green";
    if (percentile > 80) barColor = "light-blue";
    if (percentile > 90) barColor = "blue";
  } else if (grade) {
    if (percentile <= 20) barColor = "red";
    if (percentile > 20) barColor = "orange";
    if (percentile > 40) barColor = "yellow";
    if (percentile > 60) barColor = "green";
    if (percentile > 80) barColor = "light-blue";
    if (percentile > 90) barColor = "blue";
    //if (score <= colorCodingRules[grade][testName][term].red) barColor = "red";
    //if (score >= colorCodingRules[grade][testName][term].yellow) barColor = "yellow";
    //if (score >= colorCodingRules[grade][testName][term].green) barColor = "green";
    //if (score >= colorCodingRules[grade][testName][term].blue) barColor = "blue";
  } else {
    barColor = "none";
  }

  if (outputType === 'hex') {
    switch (barColor) {
      case "red":
        barColor = "da2f2f";
        break;
      case "orange":
        barColor = "ffa500";
        break;
      case "yellow":
        barColor = "dada1f";
        break;
      case "green":
        barColor = "227922";
        break;
      case "light-blue":
        barColor = "add8e6";
        break;
      case "blue":
        barColor = "4e4ed0";
        break;
      default:
        barColor = "ffffff";
        break;
    }
  }

  return barColor;

}

export function colorCodePercentile(percentile, outputType) {
  // output type can be 'hex' or, default, 'name'
  let color = "none";

  if (percentile <= 20) color = "red";
  if (percentile > 20) color = "orange";
  if (percentile > 40) color = "yellow";
  if (percentile > 60) color = "green";
  if (percentile > 80) color = "light-blue";
  if (percentile > 90) color = "blue";

  if (outputType === 'hex') {
    switch (color) {
      case "red":
        color = "da2f2f";
        break;
      case "orange":
        color = "ffa500";
        break;
      case "yellow":
        color = "dada1f";
        break;
      case "green":
        color = "227922";
        break;
      case "light-blue":
        color = "add8e6";
        break;
      case "blue":
        color = "4e4ed0";
        break;
      default:
        color = "ffffff";
        break;
    }
  }

  return color;
}

export function getCurrentSy() {
  var settings = JSON.parse(window.localStorage.getItem('settings'));
  // Prepare latest EAL in current year for header EAL info
  const today = moment();
  var currentSy = null;
  settings.schoolYears.map(sy => {
    if ((today > moment(sy.startDate)) && (today < moment(sy.endDate))) {
      currentSy = sy;
    }
  });
  return currentSy;
}


export function getCurrentSyId() {
  var settings = JSON.parse(window.localStorage.getItem('settings'));
  // Prepare latest EAL in current year for header EAL info
  const today = moment();
  var currentSy = null;
  settings.schoolYears.map(sy => {
    if ((today > moment(sy.startDate)) && (today < moment(sy.endDate))) {
      currentSy = sy._id;
    }
  });
  return currentSy;
}

export function getCurrentSyTitle() {
  var settings = JSON.parse(window.localStorage.getItem('settings'));
  // Prepare latest EAL in current year for header EAL info
  const today = moment();
  var currentSy = null;
  settings.schoolYears.map(sy => {
    if ((today > moment(sy.startDate)) && (today < moment(sy.endDate))) {
      currentSy = sy.title;
    }
  });
  return currentSy;
}


export function getSyForDate(date, schoolYears) {
  let syForDate = null;
  date = moment(date);
  schoolYears.map(function (sy) {
    let start = moment(sy.startDate, 'YYYY-MM-DD');
    let end = moment(sy.endDate, 'YYYY-MM-DD');
    if (date.isAfter(start) && date.isBefore(end)) {
      syForDate = sy._id;
    }
  });
  return syForDate;
}

export function getUserGroups() {
  var user = JSON.parse(window.localStorage.getItem('user'));

  var admin = user.groups.includes('admin');
  var writeEs = user.groups.includes('writeEs');
  var couns = user.groups.includes('couns');
  var eallss = user.groups.includes('eallss');
  var admission = user.groups.includes('admission');
  var langProfileEdit = user.groups.includes('language');
  // console.log('admin', admin);
  // console.log('writeEs', writeEs);
  // console.log('eallss', eallss);
  // console.log('couns', couns);
  // console.log('admission', admission);
  // console.log('language', langProfileEdit);
  var permission = [];
  // if (admin) { return 'admin'; }
  // if (couns) { return 'couns'; }
  // if (writeEs) { return 'writeEs'; }
  // if (eallss) { return 'eallss'; }
  // if (admission) { return 'admission'; }
  if (admin) { permission.push('admin'); }
  if (couns) { permission.push('couns'); }
  if (writeEs) { permission.push('writeEs'); }
  if (eallss) { permission.push('eallss'); }
  if (admission) { permission.push('admission'); }
  if (langProfileEdit) { permission.push('language'); }
  return permission;
}

export function findElement(arr, propName, propValue) {
  for (var i = 0; i < arr.length; i++)
    if (arr[i][propName] == propValue)
      return arr[i];
}

export function getSchool(grade) {
  if (
    grade === "Kindergarten" ||
    grade === "Multiage 3" ||
    grade === "Multiage 4" ||
    grade === "Grade 1" ||
    grade === "Grade 2" ||
    grade === "Grade 3" ||
    grade === "Grade 4" ||
    grade === "Grade 5"
  ) {
    return 'ES';
  }

  if (
    grade === "Grade 6" ||
    grade === "Grade 7" ||
    grade === "Grade 8"
  ) {
    return 'MS';
  }

  if (
    grade === "Grade 9" ||
    grade === "Grade 10" ||
    grade === "Grade 11" ||
    grade === "Grade 12"
  ) {
    return 'HS';
  }
};

export function getHeadingFill(school) {
  if (school === 'ES') {
    return { r: 78, g: 192, b: 180 };
  }
  if (school === 'MS') {
    return { r: 164, g: 51, b: 124 };
  }
  if (school === 'HS') {
    return { r: 98, g: 185, b: 232 };
  }
}

export function filterStudents(students, filter, module) {

  /*
   * Filter is expected to be object with these properties:
   * - inactive (boolean)
   * - text (string)
   * - grade (string)
   *
   */

  var studentModule = '';
  switch (module) {
    case 'general': studentModule = 'general'; break;
    case 'map': studentModule = 'maps'; break;
    case 'es': studentModule = 'ess'; break;
    case 'writing': studentModule = 'writings'; break;
    case 'ncs': studentModule = 'ncs'; break;
    case 'psat': studentModule = 'psats'; break;
    case 'sat': studentModule = 'osats'; break;
    case 'erb': studentModule = 'erbs'; break;
    case 'cem': studentModule = 'cems'; break;
    case 'ibdp': studentModule = 'ibdps'; break;
    case 'grading': studentModule = 'reporting'; break;
    case 'counselor-data': studentModule = 'counselorData'; break;
    case 'eal': studentModule = 'eals'; break;
    case 'language-profile': studentModule = 'languageProfile'; break;
    case 'lrc': studentModule = 'lrcs'; break;
    case 'documents': studentModule = 'documents'; break;
    case 'comments': studentModule = 'comments'; break;
    default: studentModule = 'general'; break;
  }

  const filteredStudents = [];
  const currentSy = getCurrentSy();
  const currentSyId = getCurrentSyId();
  const currentSyTitle = getCurrentSyTitle();
  let hasCurrentYear = false;

  let date = null;
  let start = null;
  let end = null;

  students && students.forEach((student) => {
    if (student.inactive === false) { student.inactiveText = 'Active' }
    if (student.inactive === true) { student.inactiveText = 'Inactive' }
    const filterableFields = student.firstName + " " + student.lastName + " " + student.citizenship + " " + student.birthday + " " + student.advisor + " " + student.legacyID + " " + student.graduationYear;
    if (filterableFields.toLowerCase().indexOf(filter.text.toLowerCase()) === -1 || ((student.currentGrade !== filter.grade) && (filter.grade !== 'All'))) { return; }
    if (filter.inactive === true && student.inactive === false) { return; }
    if (filter.inactive === false && student.inactive === true) { return; }
    // console.log(student);
    if (studentModule === 'general') {
      filteredStudents.push(student);
    } else if (filter.noData === true) {
      filteredStudents.push(student);
    } else { // because latestReporting is object and all others are arrays
      if (studentModule === 'latestReporting' && student[studentModule] && student[studentModule].syId) {
        filteredStudents.push(student);
      }
      if (student[studentModule] && student[studentModule].length > 0 && student[studentModule][0] != undefined) {
        switch (module) {
          case 'map123':
          case 'es123':
          case 'eal123':
          case 'grading123':
          case 'lrc123':
            hasCurrentYear = false;
            student[studentModule] && student[studentModule].forEach((mod) => {
              //console.log(mod);
              if ((mod.sy) && (mod.sy.title) && (mod.sy.title === currentSyTitle)) {
                hasCurrentYear = true;
              }
            });
            if (hasCurrentYear) filteredStudents.push(student);
            break;
          case 'psat123':
            hasCurrentYear = false;
            student[studentModule] && student[studentModule].forEach((mod) => {
              if (mod.latestPsatDate) {
                date = moment(mod.latestPsatDate);
                start = moment(currentSy.startDate, 'YYYY-MM-DD');
                end = moment(currentSy.endDate, 'YYYY-MM-DD');
                if (date.isAfter(start) && date.isBefore(end)) {
                  hasCurrentYear = true;
                }
              }
            });
            if (hasCurrentYear) filteredStudents.push(student);
            break;
          default: filteredStudents.push(student); break;
        }

      }
    }
  });
  return filteredStudents;
};


export function generateStandardPdfReport(student, options) {

  var output = options.output;
  var sy = options.sy;
  var modules = options.modules;
  var multi = false;
  var moduleSettings = options.moduleSettings;
  var settings = JSON.parse(window.localStorage.getItem('settings'));

  if (sy && sy.length > 0) {
    multi = true;

    // sort SY
    let fullSys = [];
    sy.map(y => {
      fullSys.push(findElement(settings.schoolYears, "_id", y));
    });
    fullSys.sort(function (a, b) {
      var keyA = new Date(a.startDate),
        keyB = new Date(b.startDate);
      // Compare the 2 dates
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });
    let sortedSy = [];
    fullSys.map(fsy => sortedSy.push(fsy._id));
    sy = sortedSy;

  }
  if (!modules || modules.length < 1) {
    module = {
      eal: true,
      map: true,
      ess: true,
      erb: true,
      psat: true,
      sat: true,
      cem: true,
      counselor: true,
      comments: true,
    };
  } else {
    module = {
      eal: false,
      map: false,
      ess: false,
      erb: false,
      psat: false,
      sat: false,
      cem: false,
      counselor: false,
      comments: false,
    };
    modules.forEach(function (mod) {
      module[mod] = true;
    });
  }
  var doc = new jsPDF("portrait", "mm", "a4");
  var school = getSchool(student.currentGrade);
  var standardReport = true;
  if (modules && modules.length > 0 || sy && sy.length > 0) {
    var standardReport = false;
  }
  var headingFill = standardReport ? getHeadingFill(school) : { r: 128, g: 128, b: 128 };
  var headingTextColor = { r: 255, g: 255, b: 255 };
  var margin = { t: 15, r: 195, b: 282, l: 15, }
  var cursor = margin.t;

  return new Promise(function (resolve, reject) {

    reportHeading();
    explanation();
    basicInfo();
    languageProfile();

    if (!getUserGroups().includes('admin')) {
      generateDoNotPrintStamp();
    }

    /****
    *
    * WIDA
    *
    ****/

    var tableOptions = {
      doc: doc,
      spaceAfter: 0,
    }

    if (module.eal && (moduleSettings[2].visibleForGrades.indexOf(student.currentGrade) != -1)) {
      cursor += 5;
      var rowsWidaHeading = [
        [{ content: 'WIDA MODEL Assessment (Measure of Developing English Language)', fill: headingFill, textColor: headingTextColor }],
        [{ content: "The WIDA Model Assessment gives a snapshot of a student's English language proficiency in Reading, Writing, Listening and Speaking. Note: WIDA Reading scores do not reflect grade-level reading expectations, but are more a measure of test-taking abilities and/or ability to infer vocabulary from context.", fontSize: 8 }],
        ['Support Type', 'Teacher', { content: 'WIDA Proficiency Level', span: 2 }],
      ];
      generateTable(rowsWidaHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var eal = null;
          student.eals && student.eals.forEach(function (obj) {
            if (obj.sy._id === sy) {
              eal = obj;
            }
          });
          var rowsWidaBody = [
            [`${eal != null && eal.typeOfSupport || 'N/A'}`, `${eal != null && eal.providedBy || 'N/A'}`, { content: `${eal != null && eal.profLevel || 'N/A'}`, span: 2 }],
            [`Reading: ${eal != null && eal.readingProf || 'N/A'}`, `Writing: ${eal != null && eal.writingProf || 'N/A'}`, `Speaking: ${eal != null && eal.speakingProf || 'N/A'}`, `Listening: ${eal != null && eal.listeningProf || 'N/A'}`],
          ];
          generateTable(rowsWidaBody, tableOptions);
          /*
          */
        });
      } else {
        // generate most recent
        var rowsWidaBody = [
          [`${student.eals && student.eals[0] != null && student.eals[0].typeOfSupport || 'N/A'}`, `${student.eals && student.eals[0] != null && student.eals[0].providedBy || 'N/A'}`, { content: `${student.eals && student.eals[0] != null && student.eals && student.eals[0].profLevel || 'N/A'}`, span: 2 }],
          [`Reading: ${student.eals && student.eals[0] != null && student.eals && student.eals[0].readingProf || 'N/A'}`, `Writing: ${student.eals && student.eals[0] != null && student.eals && student.eals[0].writingProf || 'N/A'}`, `Speaking: ${student.eals && student.eals[0] != null && student.eals && student.eals[0].speakingProf || 'N/A'}`, `Listening: ${student.eals && student.eals[0] != null && student.eals && student.eals[0].listeningProf || 'N/A'}`],
        ];
        generateTable(rowsWidaBody, tableOptions);
      }
    }

    /****
    *
    * MAP
    *
    ****/

    if (module.map && (moduleSettings[1].visibleForGrades.indexOf(student.currentGrade) != -1)) {
      cursor += 5;
      var rowsMapHeading = [
        [{ content: 'Measures of Academic Progress (MAP)', fill: headingFill, textColor: headingTextColor }],
        [{ content: "MAP is required for students in grades 3-9. RIT scores tell us at what level students are ready to learn. Percentiles compare to all other students (worldwide) who have taken the test.", fontSize: 8 }],
        ['Math', 'Reading', 'Language Use'],
      ];
      generateTable(rowsMapHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var map = null;
          student.maps && student.maps.forEach(function (obj) {
            if (obj.sy._id === sy) {
              map = obj;
            }
          });
          var rowsMapBody = [
            [
              `RIT: ${map && map.math.ritScore != null && map.math.ritScore || 'N/A'}`,
              `%ile: ${map && map.math.percentile != null && map.math.percentile || 'N/A'}`,
              `RIT: ${map && map.reading.ritScore != null && map.reading.ritScore || 'N/A'}`,
              `%ile: ${map && map.reading.percentile != null && map.reading.percentile || 'N/A'}`,
              `RIT: ${map && map.language.ritScore != null && map.language.ritScore || 'N/A'}`,
              `%ile: ${map && map.language.percentile != null && map.language.percentile || 'N/A'}`,
            ],
          ];
          generateTable(rowsMapBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsMapBody = [
          [
            `RIT: ${student.maps && student.maps[0] && student.maps[0].math && student.maps[0].math.ritScore != null && student.maps[0].math.ritScore || 'N/A'}`,
            `%ile: ${student.maps && student.maps[0] && student.maps[0].math && student.maps[0].math.percentile != null && student.maps[0].math.percentile || 'N/A'}`,
            `RIT: ${student.maps && student.maps[0] && student.maps[0].reading && student.maps[0].reading.ritScore != null && student.maps[0].reading.ritScore || 'N/A'}`,
            `%ile: ${student.maps && student.maps[0] && student.maps[0].reading && student.maps[0].reading.percentile != null && student.maps[0].reading.percentile || 'N/A'}`,
            `RIT: ${student.maps && student.maps[0] && student.maps[0].language && student.maps[0].language.ritScore != null && student.maps[0].language.ritScore || 'N/A'}`,
            `%ile: ${student.maps && student.maps[0] && student.maps[0].language && student.maps[0].language.percentile != null && student.maps[0].language.percentile || 'N/A'}`,
          ],
        ];
        generateTable(rowsMapBody, tableOptions);
      }
    }

    /****
    *
    * Math Bench
    *
    ****/

    if (module.ess && (moduleSettings[3].visibleForGrades.indexOf(student.currentGrade) != -1)) {
      cursor += 5;
      var rowsMathBenchHeading = [
        [{ content: 'Math Benchmark Assessment', fill: headingFill, textColor: headingTextColor }],
        [{ content: "The Math Benchmark assessment is a comprehensive assessment of the critical areas in the prior grade level.", fontSize: 8 }],
        ['Concept 1', 'Concept 2', 'Concept 3', 'Concept 4', 'Problem Solv.', 'Modeling', 'Communication'],
      ];
      generateTable(rowsMathBenchHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var ess = null;
          student.ess && student.ess.forEach(function (obj) {
            if (obj.sy._id === sy) {
              ess = obj;
            }
          });
          var rowsMathBenchBody = [
            [
              `${ess && ess.mathBenchmarkAssessmentBoyConcept1 != null && ess.mathBenchmarkAssessmentBoyConcept1 || 'N/A'}`,
              `${ess && ess.mathBenchmarkAssessmentBoyConcept2 != null && ess.mathBenchmarkAssessmentBoyConcept2 || 'N/A'}`,
              `${ess && ess.mathBenchmarkAssessmentBoyConcept3 != null && ess.mathBenchmarkAssessmentBoyConcept3 || 'N/A'}`,
              `${ess && ess.mathBenchmarkAssessmentBoyConcept4 != null && ess.mathBenchmarkAssessmentBoyConcept4 || 'N/A'}`,
              `${ess && ess.mathBenchmarkAssessmentBoyProblemSolving != null && ess.mathBenchmarkAssessmentBoyProblemSolving || 'N/A'}`,
              `${ess && ess.mathBenchmarkAssessmentBoyModeling != null && ess.mathBenchmarkAssessmentBoyModeling || 'N/A'}`,
              `${ess && ess.mathBenchmarkAssessmentBoyCommunication != null && ess.mathBenchmarkAssessmentBoyCommunication || 'N/A'}`,
            ],
          ];
          generateTable(rowsMathBenchBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsMathBenchBody = [
          [
            `${student.ess && student.ess[0] && student.ess[0].mathBenchmarkAssessmentBoyConcept1 != null && student.ess[0].mathBenchmarkAssessmentBoyConcept1 || 'N/A'}`,
            `${student.ess && student.ess[0] && student.ess[0].mathBenchmarkAssessmentBoyConcept2 != null && student.ess[0].mathBenchmarkAssessmentBoyConcept2 || 'N/A'}`,
            `${student.ess && student.ess[0] && student.ess[0].mathBenchmarkAssessmentBoyConcept3 != null && student.ess[0].mathBenchmarkAssessmentBoyConcept3 || 'N/A'}`,
            `${student.ess && student.ess[0] && student.ess[0].mathBenchmarkAssessmentBoyConcept4 != null && student.ess[0].mathBenchmarkAssessmentBoyConcept4 || 'N/A'}`,
            `${student.ess && student.ess[0] && student.ess[0].mathBenchmarkAssessmentBoyProblemSolving != null && student.ess[0].mathBenchmarkAssessmentBoyProblemSolving || 'N/A'}`,
            `${student.ess && student.ess[0] && student.ess[0].mathBenchmarkAssessmentBoyModeling != null && student.ess[0].mathBenchmarkAssessmentBoyModeling || 'N/A'}`,
            `${student.ess && student.ess[0] && student.ess[0].mathBenchmarkAssessmentBoyCommunication != null && student.ess[0].mathBenchmarkAssessmentBoyCommunication || 'N/A'}`,
          ],
        ];
        generateTable(rowsMathBenchBody, tableOptions);
      }

      /****
      *
      * Literary Ass
      *
      ****/

      cursor += 5;

      var rowsLiteraryAssHeading = [
        [{ content: 'Literacy Assessments', fill: headingFill, textColor: headingTextColor }],
        [{ content: "The Fountas and Pinnell Reading Inventory measures the instructional reading level of the student. The Narrative writing prompt is scored with a common rubric within each grade level aligned to the writing benchmarks.", fontSize: 8 }],
        ['Fountas & Pinnell Reading', 'Narrative Writing Structure', 'Narrative Writing Development', 'Narrative Writing Conventions'],
      ];
      generateTable(rowsLiteraryAssHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var ess = null;
          student.ess && student.ess.forEach(function (obj) {
            if (obj.sy._id === sy) {
              ess = obj;
            }
          });
          var rowsLiteraryAssBody = [
            [
              `BoY: ${ess && ess.fountasAndPinnellReadingBoy != null && ess.fountasAndPinnellReadingBoy || 'N/A'}, MoY: ${ess && ess.fountasAndPinnellReadingMoy != null && ess.fountasAndPinnellReadingMoy || 'N/A'}, EoY: ${ess && ess.fountasAndPinnellReadingEoy != null && ess.fountasAndPinnellReadingEoy || 'N/A'}`,
              `BoY: ${ess && ess.narrativeWritingBoyStructure != null && ess.narrativeWritingBoyStructure || 'N/A'}, EoY: ${ess && ess.narrativeWritingEoyStructure != null && ess.narrativeWritingEoyStructure || 'N/A'}`,
              `BoY: ${ess && ess.narrativeWritingBoyDevelopment != null && ess.narrativeWritingBoyDevelopment || 'N/A'}, EoY: ${ess && ess.narrativeWritingEoyDevelopment != null && ess.narrativeWritingEoyDevelopment || 'N/A'}`,
              `BoY: ${ess && ess.narrativeWritingBoyConventions != null && ess.narrativeWritingBoyConventions || 'N/A'}, EoY: ${ess && ess.narrativeWritingEoyConventions != null && ess.narrativeWritingEoyConventions || 'N/A'}`,
            ],
          ];
          generateTable(rowsLiteraryAssBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsLiteraryAssBody = [
          [
            `BoY: ${student.ess && student.ess[0] && student.ess[0].fountasAndPinnellReadingBoy != null && student.ess[0].fountasAndPinnellReadingBoy || 'N/A'}, MoY: ${student.ess && student.ess[0] && student.ess[0].fountasAndPinnellReadingMoy != null && student.ess[0].fountasAndPinnellReadingMoy || 'N/A'}, EoY: ${student.ess && student.ess[0] && student.ess[0].fountasAndPinnellReadingEoy != null && student.ess[0].fountasAndPinnellReadingEoy || 'N/A'}`,
            `BoY: ${student.ess && student.ess[0] && student.ess[0].narrativeWritingBoyStructure != null && student.ess[0].narrativeWritingBoyStructure || 'N/A'}, EoY: ${student.ess && student.ess[0] && student.ess[0].narrativeWritingEoyStructure != null && student.ess[0].narrativeWritingEoyStructure || 'N/A'}`,
            `BoY: ${student.ess && student.ess[0] && student.ess[0].narrativeWritingBoyDevelopment != null && student.ess[0].narrativeWritingBoyDevelopment || 'N/A'}, EoY: ${student.ess && student.ess[0] && student.ess[0].narrativeWritingEoyDevelopment != null && student.ess[0].narrativeWritingEoyDevelopment || 'N/A'}`,
            `BoY: ${student.ess && student.ess[0] && student.ess[0].narrativeWritingBoyConventions != null && student.ess[0].narrativeWritingBoyConventions || 'N/A'}, EoY: ${student.ess && student.ess[0] && student.ess[0].narrativeWritingEoyConventions != null && student.ess[0].narrativeWritingEoyConventions || 'N/A'}`,
          ],
        ];
        generateTable(rowsLiteraryAssBody, tableOptions);
      }
    }

    /****
    *
    * ERB
    *
    ****/

    if (module.erb && (moduleSettings[6].visibleForGrades.indexOf(student.currentGrade) != -1)) {
      cursor += 5;
      var rowsErbHeading = [
        [{ content: 'ERB Comprehensive Testing Program (CTP)', fill: headingFill, textColor: headingTextColor }],
        [{ content: "CTP tests ability and achievement and is required for students in grades 7 and 9. National percentiles compare to students in non-selective schools. Independent percentiles compare to students in selective private schools. To allow for triangulation with other data, figures here are percentiles. Scaled scores can be found in the Dashbourd", fontSize: 8 }],
        ['Quant. Reasoning', 'Math 1 & 2', 'Algebra 1 (grade 9)', 'Verbal Reasoning', 'Vocabulary'],
        ['Nat`l %', 'Ind %', 'Nat`l %', 'Ind %', 'Nat`l %', 'Ind %', 'Nat`l %', 'Ind %', 'Nat`l %', 'Ind %'],
      ];
      generateTable(rowsErbHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var erb = null;
          student.erbs && student.erbs.forEach(function (obj) {
            if (obj.sy._id === sy) {
              erb = obj;
            }
          });
          var rowsErbBody = [
            [
              erb && erb != null && erb.testsTaken[2] != null && erb.testsTaken[2].percentileNatNorm != null && erb.testsTaken[2].percentileNatNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[2] != null && erb.testsTaken[2].percentileIndNorm != null && erb.testsTaken[2].percentileIndNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[3] != null && erb.testsTaken[3].percentileNatNorm != null && erb.testsTaken[3].percentileNatNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[3] != null && erb.testsTaken[3].percentileIndNorm != null && erb.testsTaken[3].percentileIndNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[4] != null && erb.testsTaken[4].percentileNatNorm != null && erb.testsTaken[4].percentileNatNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[4] != null && erb.testsTaken[4].percentileIndNorm != null && erb.testsTaken[4].percentileIndNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[0] != null && erb.testsTaken[0].percentileNatNorm != null && erb.testsTaken[0].percentileNatNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[0] != null && erb.testsTaken[0].percentileIndNorm != null && erb.testsTaken[0].percentileIndNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[1] != null && erb.testsTaken[1].percentileNatNorm != null && erb.testsTaken[1].percentileNatNorm.toString() || 'N/A',
              erb && erb != null && erb.testsTaken[1] != null && erb.testsTaken[1].percentileIndNorm != null && erb.testsTaken[1].percentileIndNorm.toString() || 'N/A',
            ],
          ];
          generateTable(rowsErbBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsErbBody = [
          [
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[2] != null && student.erbs[0].testsTaken[2].percentileNatNorm != null && student.erbs[0].testsTaken[2].percentileNatNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[2] != null && student.erbs[0].testsTaken[2].percentileIndNorm != null && student.erbs[0].testsTaken[2].percentileIndNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[3] != null && student.erbs[0].testsTaken[3].percentileNatNorm != null && student.erbs[0].testsTaken[3].percentileNatNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[3] != null && student.erbs[0].testsTaken[3].percentileIndNorm != null && student.erbs[0].testsTaken[3].percentileIndNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[4] != null && student.erbs[0].testsTaken[4].percentileNatNorm != null && student.erbs[0].testsTaken[4].percentileNatNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[4] != null && student.erbs[0].testsTaken[4].percentileIndNorm != null && student.erbs[0].testsTaken[4].percentileIndNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[0] != null && student.erbs[0].testsTaken[0].percentileNatNorm != null && student.erbs[0].testsTaken[0].percentileNatNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[0] != null && student.erbs[0].testsTaken[0].percentileIndNorm != null && student.erbs[0].testsTaken[0].percentileIndNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[1] != null && student.erbs[0].testsTaken[1].percentileNatNorm != null && student.erbs[0].testsTaken[1].percentileNatNorm.toString() || 'N/A',
            student.erbs && student.erbs[0] != null && student.erbs[0].testsTaken[1] != null && student.erbs[0].testsTaken[1].percentileIndNorm != null && student.erbs[0].testsTaken[1].percentileIndNorm.toString() || 'N/A',
          ],
        ];
        generateTable(rowsErbBody, tableOptions);
      }
    }

    /****
    *
    * PSAT
    *
    ****/

    if (module.psat && (moduleSettings[4].visibleForGrades.indexOf(student.currentGrade) != -1)) {
      cursor += 5;
      var rowsPsatHeading = [
        [{ content: 'Preliminary SAT (PSAT)', fill: headingFill, textColor: headingTextColor }],
        [{ content: "PSAT is required in grade 10 and optional in grade 11. Scale of 160-760. PSAT Benchmark (on track) for Reading is 460. PSAT Benchmark (on track) for Math is 510. Comparison precentile is compared to typical U.S. College Board test-takers in the same grade level as the student.", fontSize: 8 }],
        ['Math', 'Evidence-Based Reading and Writing (ERW)'],
      ];
      generateTable(rowsPsatHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var psat = null;
          student.psats && student.psats.forEach(function (obj) {
            if (obj.sy._id === sy) {
              psat = obj;
            }
          });
          var rowsPsatBody = [
            [
              `Scaled Score: ${psat != null && psat.latestPsatMathSection || 'N/A'}`,
              `%ile: ${psat != null && psat.percentileNatRepPsatMathSection || 'N/A'}`,
              `Scaled Score: ${psat != null && psat.latestPsatEbrw || 'N/A'}`,
              `%ile: ${psat != null && psat.percentileNatRepPsatEbrw || 'N/A'}`,
            ],
          ];
          generateTable(rowsPsatBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsPsatBody = [
          [
            `Scaled Score: ${student.psats && student.psats[0] != null && student.psats[0].latestPsatMathSection || 'N/A'}`,
            `%ile: ${student.psats && student.psats[0] != null && student.psats[0].percentileNatRepPsatMathSection || 'N/A'}`,
            `Scaled Score: ${student.psats && student.psats[0] != null && student.psats[0].latestPsatEbrw || 'N/A'}`,
            `%ile: ${student.psats && student.psats[0] != null && student.psats[0].percentileNatRepPsatEbrw || 'N/A'}`,
          ],
        ];
        generateTable(rowsPsatBody, tableOptions);
      }
    }

    if (!multi && (module.other || (module.sat && school === 'HS') || (module.cem && school === 'HS'))) {
      doc.addPage();
      cursor = margin.t;
      reportHeading();
    }

    /****
    *
    * SAT
    *
    ****/

    if (module.sat && (moduleSettings[5].visibleForGrades.indexOf(student.currentGrade) != -1)) {
      cursor += 5;
      var rowsSatHeading = [
        [{ content: 'Scholastic Aptitude Test (SAT)', fill: headingFill, textColor: headingTextColor }],
        [{ content: "SAT is optional in grade 11 and 12. Scale of 200-800. SAT Benchmark (on track) for Reading is 480. SAT Benchmark (on track) for Math is 530. Comparison percentile is compared to the scores of students who typically take the test (worldwide)", fontSize: 8 }],
        ['Math', 'Evidence-Based Reading and Writing (ERW)'],
      ];
      generateTable(rowsSatHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var osat = null;
          student.osats && student.osats.forEach(function (obj) {
            if (obj.sy._id === sy) {
              osat = obj;
            }
          });
          var rowsSatBody = [
            [
              `Scaled Score: ${osat != null && osat.latestOsatMathSection || 'N/A'}`,
              `%ile: ${osat != null && osat.percentileNatRepOsatMathSection || 'N/A'}`,
              `Scaled Score: ${osat != null && osat.latestOsatEbrw || 'N/A'}`,
              `%ile: ${osat != null && osat.percentileNatRepOsatEbrw || 'N/A'}`,
            ],
          ];
          generateTable(rowsSatBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsSatBody = [
          [
            `Scaled Score: ${student.osats && student.osats[0] != null && student.osats[0].latestOsatMathSection || 'N/A'}`,
            `%ile: ${student.osats && student.osats[0] != null && student.osats[0].percentileNatRepOsatMathSection || 'N/A'}`,
            `Scaled Score: ${student.osats && student.osats[0] != null && student.osats[0].latestOsatEbrw || 'N/A'}`,
            `%ile: ${student.osats && student.osats[0] != null && student.osats[0].percentileNatRepOsatEbrw || 'N/A'}`,
          ],
        ];
        generateTable(rowsSatBody, tableOptions);
      }
    }

    /****
    *
    * CEM
    *
    ****/

    if (module.cem && (moduleSettings[7].visibleForGrades.indexOf(student.currentGrade) != -1)) {
      cursor += 5;
      var rowsCemHeading = [
        [{ content: 'Centre for Evaluation and Monitoring (CEM) IB Evaluation', fill: headingFill, textColor: headingTextColor }],
        [{ content: "CEM is required of all students at the end of grade 10. It gives us insight into possible performance on the IB exam and helps us comparea bility and achievement. Scale of 50-150. Median score is 100. Comparison percentile is compared to all other students (worldwide) who have taken the test.", fontSize: 8 }],
        [{ content: 'Math', span: 2 }, { content: 'Vocabulary', span: 2 }, { content: 'Non-Verbal (Logic)', span: 2 }, { content: 'Overall Ability', span: 2 }, 'Overall Stanine'],
        ['Scaled', '%ile', 'Scaled', '%ile', 'Scaled', '%ile', 'Scaled', '%ile', ''],
      ];
      generateTable(rowsCemHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          var cem = null;
          student.cems && student.cems.forEach(function (obj) {
            if (obj.sy._id === sy) {
              cem = obj;
            }
          });
          var rowsCemBody = [
            [
              cem != null && cem.scores[0] != null && cem.scores[2].score.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[2].percentile.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[1].score.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[1].percentile.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[3].score.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[3].percentile.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[0].score.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[3].percentile.toString() || 'N/A',
              cem != null && cem.scores[0] != null && cem.scores[0].stanine.toString() || 'N/A',
            ],
          ];
          generateTable(rowsCemBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsCemBody = [
          [
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[2].score.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[2].percentile.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[1].score.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[1].percentile.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[3].score.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[3].percentile.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[0].score.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[3].percentile.toString() || 'N/A',
            student.cems && student.cems[0] != null && student.cems[0].scores[0] != null && student.cems[0].scores[0].stanine.toString() || 'N/A',
          ],
        ];
        generateTable(rowsCemBody, tableOptions);
      }
    }

    /****
    *
    * Counselor Data
    *
    ****/

    //if (module.counselor && (moduleSettings[7].visibleForGrades.indexOf(student.currentGrade) != -1)) {
    if (module.counselor && !standardReport) {
      cursor += 5;
      var rowsCounselorHeading = [
        [{ content: 'Counselor Data', fill: headingFill, textColor: headingTextColor }],
        ['date', 'providedBy', { content: 'Issues', span: 2 }, { content: 'Recommendation', span: 2 }, { content: 'Interventions', span: 2 }],
      ];
      generateTable(rowsCounselorHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          //var counselor = null;
          var counselor = [];
          student.counselorData && student.counselorData.forEach(function (obj) {
            if (obj.sy._id === sy) {
              counselor.push(obj);
            }
          });
          var rowsCounselorBody = [];
          counselor.map(couns => {
            //console.log(couns);
            if (couns.visibleToTeacher) {
              rowsCounselorBody.push(
                [
                  { content: couns != null && couns.date || 'N/A' },
                  { content: couns != null && couns.providedBy || 'N/A' },
                  { content: couns != null && couns.issues || 'N/A', span: 2 },
                  { content: couns != null && couns.interventions || 'N/A', span: 2 },
                  { content: couns != null && couns.recommendation || 'N/A', span: 2 },
                ]
              );
            } else {
              // rowsCounselorBody.push(
              //   [
              //     {content: 'N/A'},
              //     {content: 'N/A'},
              //     {content: 'N/A', span: 2},
              //     {content: 'N/A', span: 2},
              //     {content: 'N/A', span: 2},
              //   ]
              // );
            }

          });
          generateTable(rowsCounselorBody, tableOptions);
        });
      } else {
        // generate most recent
        if (student.counselorData[0].visibleToTeacher) {
          var rowsCounselorBody = [
            [
              { content: student.counselorData && student.counselorData[0] != null && student.counselorData[0].date || 'N/A' },
              { content: student.counselorData && student.counselorData[0] != null && student.counselorData[0].providedBy || 'N/A' },
              { content: student.counselorData && student.counselorData[0] != null && student.counselorData[0].issues || 'N/A', span: 2 },
              { content: student.counselorData && student.counselorData[0] != null && student.counselorData[0].interventions || 'N/A', span: 2 },
              { content: student.counselorData && student.counselorData[0] != null && student.counselorData[0].recommendation || 'N/A', span: 2 },
            ],
          ];
        } else {
          var rowsCounselorBody = [
            [
              { content: 'N/A' },
              { content: 'N/A' },
              { content: 'N/A', span: 2 },
              { content: 'N/A', span: 2 },
              { content: 'N/A', span: 2 },
            ],
          ];
        }
        generateTable(rowsCounselorBody, tableOptions);
      }
    }

    /****
    *
    * Comments
    *
    ****/

    //if (module.counselor && (moduleSettings[7].visibleForGrades.indexOf(student.currentGrade) != -1)) {
    if (module.comments && !standardReport) {
      cursor += 5;
      var rowsCommentsHeading = [
        [{ content: 'Comments', fill: headingFill, textColor: headingTextColor }],
        ['Date', 'Author', { content: 'Comment', span: 6 }],
      ];
      generateTable(rowsCommentsHeading, tableOptions);

      if (multi) {
        // generate table for each school year
        sy.forEach(function (sy) {

          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{ content: syTitle, fill: { r: 200, g: 200, b: 200 } }]];
          generateTable(rowsSy, tableOptions);

          // generate data for sy
          //var counselor = null;
          var comments = [];
          student.comments && student.comments.forEach(function (obj) {
            if (obj.sy._id === sy) {
              comments.push(obj);
            }
          });
          var rowsCommentsBody = [];
          comments.map(comment => {
            rowsCommentsBody.push(
              [
                { content: comment != null && comment.date || 'N/A' },
                { content: comment != null && comment.author || 'N/A' },
                { content: comment != null && comment.comment || 'N/A', span: 6 }
              ]
            );
          });
          generateTable(rowsCommentsBody, tableOptions);
        });
      } else {
        // generate most recent
        var rowsCommentsBody = [
          [
            student.comments && student.comments[0] != null && student.comments[0].date || 'N/A',
            student.comments && student.comments[0] != null && student.comments[0].author || 'N/A',
            { content: student.comments && student.comments[0] != null && student.comments[0].comment || 'N/A', span: 6 },
          ],
        ];
        generateTable(rowsCommentsBody, tableOptions);
      }
    }

    /****
    *
    * Other
    *
    ****/

    if (standardReport) {
      cursor += 5;

      var rowsOtherHeading = [
        [{ content: 'Other Information', fill: headingFill, textColor: headingTextColor }],
      ];
      generateTable(rowsOtherHeading, tableOptions);

      if (multi) {
        /*
        // generate table for each school year
        sy.forEach(function(sy) {
  
          // generate sy title
          var syTitle = findElement(settings.schoolYears, '_id', sy).title;
          var rowsSy = [[{content: syTitle, fill: {r: 200, g: 200, b: 200}}]];
          generateTable(rowsSy, tableOptions);
  
          // generate data for sy
          var eal = null;
          student.eals && student.eals.forEach(function(obj) {
            if (obj.sy._id === sy) {
              eal = obj;
            }
          });
          var lrc = null;
          student.lrcs && student.lrcs.forEach(function(obj) {
            if (obj.sy._id === sy) {
              lrc = obj;
            }
          });
          var rowsOtherBody = [
            [`Advisor / Teacher: ${student.comments && student.comments[0] != null && student.comments[0].comment || 'N/A'}`],
            [`Counselor: ${student.counselorData && student.counselorData[0] != null && student.counselorData[0].recommendation || 'N/A'}`],
            [`EAL: ${eal != null && eal.notes || 'N/A'}`],
            [`LSS: ${lrc != null && lrc.notes || 'N/A'}`],
            [`Admissions Notes: N/A`],
          ];
          generateTable(rowsOtherBody, tableOptions);
        });
        */
      } else {
        // generate most recent
        var rowsOtherBody = [
          [`Advisor / Teacher: ${student.comments && student.comments[0] != null && student.comments[0].comment || 'N/A'}`],
          [`Counselor: ${student.counselorData && student.counselorData[0] != null && student.counselorData[0].recommendation && student.counselorData[0].visibleToTeacher || 'N/A'}`],
          [`EAL: ${student.eals && student.eals[0] != null && student.eals[0].notes || 'N/A'}`],
          [`LSS: ${student.lrcs && student.lrcs[0] != null && student.lrcs[0].notes || 'N/A'}`],
          [`Admissions Notes: N/A`],
        ];
        generateTable(rowsOtherBody, tableOptions);
      }
    }


    images2();

    function extendDefaultOptions(defaults, options) {
      var extendedTableOptions = defaults;
      for (var key in options) {
        var option = options[key];
        if (extendedTableOptions[key] != null) {
          extendedTableOptions[key] = option;
        }
      }
      return extendedTableOptions;
    };

    function generateTable(rows, options) {

      var ptToMm = 0.352778;
      var defaultTableOptions = {
        doc: new jsPDF("portrait", "mm", "a4"),
        width: 180,
        margins: {
          t: 15,
          r: 195,
          b: 282,
          l: 15,
        },
        padding: 2,
        spaceAfter: 5,
        fontSize: 8,
      }

      var extendedTableOptions = extendDefaultOptions(defaultTableOptions, options);
      var doc = extendedTableOptions.doc;
      var lineH = extendedTableOptions.fontSize * ptToMm;
      var padding = extendedTableOptions.padding;

      doc.setFontSize(extendedTableOptions.fontSize);

      // generate rows
      for (var i = 0; i < rows.length; i++) {

        // new page if it can not fit
        if (cursor + lineH + 2 * padding > extendedTableOptions.margins.b) {
          doc.addPage();
          cursor = extendedTableOptions.margins.t;
          reportHeading();
        }

        cursor += padding;
        var maxH = lineH;
        var cursorX = extendedTableOptions.margins.l;

        // find out number of columns in a row
        var colNum = 0;
        for (var j = 0; j < rows[i].length; j++) {
          if (rows[i][j].span) {
            colNum += rows[i][j].span;
          } else {
            colNum++;
          }
        }

        // figure out cell width if there is no span
        var colW = extendedTableOptions.width / colNum;

        // figure out tallest cell
        for (var j = 0; j < rows[i].length; j++) {
          if (typeof rows[i][j] !== 'object') {
            var cell = {
              content: rows[i][j],
            };
          } else {
            var cell = rows[i][j];
          }

          doc.setFontSize(8);
          lineH = 10 * ptToMm;
          if (cell.fontSize) {
            doc.setFontSize(cell.fontSize);
            lineH = cell.fontSize * ptToMm;
          }

          // calculate cell width if the cell has a span
          var cellW = colW;
          if (cell.span) {
            cellW = colW * cell.span;
          }

          var textLines = doc.splitTextToSize(cell.content, cellW - 2 * padding);
          var cellH = lineH * 1.15 * textLines.length; // 1.1 seems to be standard line height in jspdf
          maxH = cellH > maxH ? cellH : maxH;
        }

        // generate cells
        for (var j = 0; j < rows[i].length; j++) {

          if (typeof rows[i][j] !== 'object') {
            var cell = {
              content: rows[i][j],
            };
          } else {
            var cell = rows[i][j];
          }
          doc.setFontSize(8);
          if (cell.fontSize) {
            doc.setFontSize(cell.fontSize);
          }

          // calculate cell width if the cell has a span
          var cellW = colW;
          if (cell.span) {
            cellW = colW * cell.span;
          }

          // execute jspdf directives if there are some
          if (cell.directive) {
            cell.directive();
          }

          var textLines = doc.splitTextToSize(cell.content, cellW - 2 * padding);

          var fill = { r: 255, g: 255, b: 255 };
          if (cell.fill) {
            fill = cell.fill;
          }

          var textColor = { r: 0, g: 0, b: 0 };
          if (cell.textColor) {
            textColor = cell.textColor;
          }

          doc.setFillColor(fill.r, fill.g, fill.b);
          doc.rect(cursorX, cursor - padding, cellW, maxH + padding * 2, "DF");

          doc.setTextColor(textColor.r, textColor.g, textColor.b);
          doc.text(
            textLines,
            cursorX + padding,
            cursor + lineH,
          );

          cursorX += cellW;
        }

        var cursorX = extendedTableOptions.margins.l;
        cursor += maxH + padding
      }

      cursor += extendedTableOptions.spaceAfter || 0;
    }



    function images2() {

      var getImageFromUrl = function (url, callback) {
        var img = new Image(), data, ret = {
          data: null,
          pending: true
        };

        img.onerror = function () {
          if (student.gender === 'Male') {
            this.src = `${config.apiHost}:${config.clientPort}/photos/avatarm.png`;
          } else {
            this.src = `${config.apiHost}:${config.clientPort}/photos/avatarf.png`;
          }
          //console.log('error');
          //throw new Error('Cannot load image: "' + url + '"');
        };

        img.onload = function () {
          var canvas = document.createElement('canvas');
          document.body.appendChild(canvas);
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          if (img.src.substr(-3) === 'png' || img.src.substr(11, 3) === 'png') {
            data = canvas.toDataURL('image/png').slice('data:image/png;base64,'.length);
            data = atob(data);
          }
          if (img.src.substr(-3) === 'jpg' || img.src.substr(11, 3) === 'jpg') {
            data = canvas.toDataURL('image/jpeg');
          }

          document.body.removeChild(canvas);
          ret['data'] = data;
          ret['pending'] = false;
          if (typeof callback === 'function') {
            callback(data);
          }
        };

        img.src = url;
        return ret;
      };

      var addPhoto = function (imgData) {
        doc.setPage(1);
        doc.addImage(imgData, 'jpeg', 15.5, 48.5, 29, 44);
      };

      var addLogos = function (imgData) {
        doc.setPage(1);
        doc.addImage(imgData, 15, 15, 485 / 6, 60 / 6);
        doc.setPage(2);
        doc.addImage(imgData, 15, 15, 485 / 6, 60 / 6);
      };

      var outputPdf = function () {
        if (output === 'open') {
          var blob = doc.output('blob');
          window.open(URL.createObjectURL(blob));
        }
        if (output === 'save') {
          doc.save(`sdp-${student.lastName.toLowerCase()}-${student.firstName.toLowerCase()}-${moment().format('YYYY-MM-DD')}.pdf`);
        }
        if (output === 'zip') {
          resolve(doc.output());
        }
      };

      var photoUrl = `${config.apiHost}:${config.clientPort}/photos/${student.legacyID}.jpg`;

      getImageFromUrl(logo, addLogos);
      getImageFromUrl(photoUrl, addPhoto);
      setTimeout(function () {
        outputPdf();
      }, 200);

    };

    function reportHeading() {
      var font = { family: 'helvetica', size: { body: 10, title: 12, small: 7.5, heading1: 21, heading2: 16, }, };
      var lineHeight = (fontSize) => 1.4 * fontSize;
      var lineHeightMm = (fontSize) => 1.4 * fontSize * ptToMm;
      var color = { text: 0, line: 0, heading: 255, };
      var ptToMm = 0.352778;
      var margin = { t: 15, r: 195, b: 282, l: 15, }
      var pageW = margin.r - margin.l;
      var profileImage = { w: 30, h: 45, x: margin.t, y: margin.l, }
      var padding = 2;

      doc.setFont(font.family);
      doc.setFontType("normal");
      doc.setFontSize(font.size.title);
      doc.text(
        ((modules && modules.length > 0) || (sy && sy.length > 0)) ? 'Student Custom Data' : 'Student Data Profile',
        margin.r,
        cursor += padding,
        'right'
      );
      doc.text(
        `For ${student.lastName}, ${student.firstName}`,
        margin.r,
        cursor += lineHeightMm(font.size.title),
        'right'
      );
      doc.setFontSize(font.size.body);
      doc.text(
        `Date of Report: ${moment().format('YYYY-MM-DD')}`,
        margin.r,
        cursor += lineHeightMm(font.size.body),
        'right'
      );
      cursor += 5;
    };

    function explanation() {
      var color = { text: 0, line: 0, heading: 255, };
      doc.setTextColor(color.text); doc.setFontSize(10);
      var content = 'All information is the most recent recorded.';
      if (standardReport) {
        content += ' Historical information can be found in the Dashboard.';
      }
      if (sy && sy.length > 0) {
        var schoolYears = "";
        sy.map((y, i) => {
          schoolYears += findElement(settings.schoolYears, '_id', y).title;
          (sy.length > 1 && (i + 1) < sy.length) ? schoolYears += ", " : "";
        });
        content = `Information is given for school year${sy.length > 1 ? 's' : ''} ${schoolYears}.`;
      }
      if (modules && modules.length > 0) {
        var mod = "";
        modules.map((m, i) => {
          mod += m;
          (modules.length > 1 && (i + 1) < modules.length) ? mod += ", " : "";
        });

        content += ` Selected module${modules.length > 1 ? 's' : ''}: ${mod.toUpperCase()}.`;
      } else if (!standardReport) {
        content += ' All modules selected.';
      }
      doc.text(content, margin.l, cursor += 10);
    };

    function contentWithBoldLabel(x, y, label, content) {
      var font = { family: 'helvetica', size: { body: 10, title: 12, small: 7.5, heading1: 21, heading2: 16, }, };
      var lineHeight = (fontSize) => 1.4 * fontSize;
      var lineHeightMm = (fontSize) => 1.4 * fontSize * ptToMm;
      var color = { text: 0, line: 0, heading: 255, };
      var ptToMm = 0.352778;
      var margin = { t: 15, r: 195, b: 282, l: 15, }
      var pageW = margin.r - margin.l;
      var profileImage = { w: 30, h: 45, x: margin.t, y: margin.l, }
      var padding = 2;

      doc.setFontStyle("bold");
      var textW = doc.getStringUnitWidth(label) * font.size.body * ptToMm;
      doc.text(label, x, y);
      doc.setFontStyle("normal");
      doc.text(content, x + textW, y);
    }

    function basicInfo() {
      var font = { family: 'helvetica', size: { body: 10, title: 12, small: 7.5, heading1: 21, heading2: 16, }, };
      var lineHeight = (fontSize) => 1.4 * fontSize;
      var lineHeightMm = (fontSize) => 1.4 * fontSize * ptToMm;
      var color = { text: 0, line: 0, heading: 255, };
      var ptToMm = 0.352778;
      var margin = { t: 15, r: 195, b: 282, l: 15, }
      var pageW = margin.r - margin.l;
      var profileImage = { w: 30, h: 45, x: margin.t, y: margin.l, }
      var padding = 2;
      // wrapper rect
      doc.rect(margin.l, cursor += 5, pageW, 45);
      // first vertical line, after photo
      doc.line(margin.l + 30, cursor, margin.l + 30, cursor + 45);
      // second vertical line, first row divider
      doc.line(
        margin.l + 30 + ((pageW - 30) / 2),
        cursor,
        margin.l + 30 + ((pageW - 30) / 2),
        cursor + 45,
      );
      // Heading rect
      doc.setFillColor(headingFill.r, headingFill.g, headingFill.b);
      doc.rect(margin.l + 30, cursor += 18, pageW - 30, 7, "DF");
      doc.line(
        margin.l + profileImage.w + ((pageW - 30) / 4),
        cursor + 7,
        margin.l + profileImage.w + ((pageW - 30) / 4),
        cursor + 27,
      );
      doc.line(
        margin.l + profileImage.w + ((pageW - 30) / 4) * 3,
        cursor + 7,
        margin.l + profileImage.w + ((pageW - 30) / 4) * 3,
        cursor + 27,
      );
      doc.line(
        margin.l + profileImage.w,
        cursor + 16,
        margin.r,
        cursor + 16,
      );

      contentWithBoldLabel(
        margin.l + profileImage.w + padding,
        cursor -= 13,
        'Current Grade:',
        ` ${student.currentGrade || 'N/A'}`
      );

      //var settings = JSON.parse(window.localStorage.getItem('settings'));
      var terms = settings.schoolYears;
      var termName = student.eals && student.eals[0] != null && student.eals[0].sy.title;

      // Prepare latest EAL in current year for header EAL info
      const today = moment();
      var currentSy = null;
      settings.schoolYears.map(sy => {
        if ((today > moment(sy.startDate)) && (today < moment(sy.endDate))) {
          currentSy = sy._id;
        }
      });

      var currentSyEals = [];
      var mostRecentCurrentSyEal = null;
      var currentSyEoyEal = null;
      var currentSyMoyEal = null;
      var currentSyBoyEal = null;
      student.eals && student.eals.map(eal => {
        if (eal.sy._id === currentSy) {
          currentSyEals.push(eal);
        }
      });

      currentSyEals.map(eal => {
        if (eal.termName === "EoY") {
          currentSyEoyEal = eal;
        }
        if (eal.termName === "MoY") {
          currentSyMoyEal = eal;
        }
        if (eal.termName === "BoY") {
          currentSyBoyEal = eal;
        }
      });

      mostRecentCurrentSyEal = currentSyEoyEal || currentSyMoyEal || currentSyBoyEal || null;
      contentWithBoldLabel(
        margin.l + profileImage.w + 75 + padding,
        cursor,
        'EAL:',
        //` ${student.eals && student.eals[0] != null && termName || 'N/A'}`
        ` ${mostRecentCurrentSyEal && mostRecentCurrentSyEal.typeOfSupport || 'N/A'}`
      );

      contentWithBoldLabel(
        margin.l + profileImage.w + padding,
        cursor += lineHeightMm(font.size.body),
        'At ISB Since:',
        ` ${student.languageProfile && student.languageProfile[0] != null && student.languageProfile[0].atAisbSince || 'N/A'}`
      );

      //termName = student.lrcs && student.lrcs[0] != null && student.lrcs[0].sy.title;

      var currentSyLrc = null;
      student.lrcs && student.lrcs.map(lrc => {
        if (lrc.sy._id === currentSy) {
          currentSyLrc = lrc;
        }
      });

      contentWithBoldLabel(
        margin.l + profileImage.w + 75 + padding,
        cursor,
        'LSS:',
        ` ${currentSyLrc ? "Yes" : "No"}`
      );

      contentWithBoldLabel(
        margin.l + profileImage.w + padding,
        cursor += lineHeightMm(font.size.body),
        'Date of Birth:',
        ` ${moment(student.birthday, 'D MMM YYYY').format('YYYY-MM-DD') || 'N/A'}`
      );
    };

    function languageProfile() {
      var font = { family: 'helvetica', size: { body: 10, title: 12, small: 7.5, heading1: 21, heading2: 16, }, };
      var lineHeight = (fontSize) => 1.4 * fontSize;
      var lineHeightMm = (fontSize) => 1.4 * fontSize * ptToMm;
      var color = { text: 0, line: 0, heading: 255, };
      var ptToMm = 0.352778;
      var margin = { t: 15, r: 195, b: 282, l: 15, }
      var pageW = margin.r - margin.l;
      var profileImage = { w: 30, h: 45, x: margin.t, y: margin.l, }
      var padding = 2;
      var string = '';
      var object = {};
      var lines = '';
      var parentObject = {};
      var textW = 0;
      var tableSpacing = 5;

      doc.setFontType("bold");
      doc.setTextColor(color.heading);
      doc.setFontSize(8);

      textW = doc.getTextDimensions('Language Profile').w * ptToMm;

      doc.text(
        'Language Profile',
        (pageW - profileImage.w) / 2 + margin.l + textW / 2,
        cursor += lineHeightMm(font.size.heading2),
      );

      doc.setTextColor(color.text);

      doc.text(
        "Nationality",
        margin.l + profileImage.w + padding,
        cursor += padding + lineHeightMm(font.size.body)
      );
      doc.text(
        "Mother Tongue",
        margin.l + profileImage.w + padding + ((pageW - 30) / 4),
        cursor
      );
      doc.text(
        "Academic Lang.",
        margin.l + profileImage.w + padding + ((pageW - 30) / 4) * 2,
        cursor
      );
      doc.text(
        "Social Languages",
        margin.l + profileImage.w + padding + ((pageW - 30) / 4) * 3,
        cursor
      );

      doc.setFontType("normal");

      string = '';
      parentObject = student.languageProfile && student.languageProfile[0];
      object = parentObject && parentObject.nationality;
      object != null && object.map((item, i) => (string += `${item.label}${(i < (object.length - 1)) ? ', ' : ''}`));
      lines = doc.splitTextToSize(string, (pageW - 30) / 4);
      doc.text(
        parentObject != null ? lines : 'N/A',
        margin.l + profileImage.w + padding,
        cursor += 2 * padding + lineHeightMm(font.size.body)
      );

      string = '';
      parentObject = student.languageProfile && student.languageProfile[0];
      object = parentObject && parentObject.motherTongue;
      object != null && object.map((item, i) => (string += `${item.label}${(i < (object.length - 1)) ? ', ' : ''}`));
      lines = doc.splitTextToSize(string, (pageW - 30) / 4);
      doc.text(
        parentObject != null ? lines : 'N/A',
        margin.l + profileImage.w + padding + ((pageW - 30) / 4),
        cursor
      );

      string = '';
      parentObject = student.languageProfile && student.languageProfile[0];
      object = parentObject && parentObject.academicLanguages;
      object != null && object.map((item, i) => (string += `${item.label}${(i < (object.length - 1)) ? ', ' : ''}`));
      lines = doc.splitTextToSize(string, (pageW - 30) / 4);
      doc.text(
        parentObject != null ? lines : 'N/A',
        margin.l + profileImage.w + padding + ((pageW - 30) / 4) * 2,
        cursor
      );

      string = '';
      object = parentObject && parentObject.socialLanguages;
      object != null && object.map((item, i) => (string += `${item.label}${(i < (object.length - 1)) ? ', ' : ''}`));
      lines = doc.splitTextToSize(string, (pageW - 30) / 4);
      doc.text(
        parentObject != null ? lines : 'N/A',
        margin.l + profileImage.w + padding + ((pageW - 30) / 4) * 3,
        cursor
      );
      cursor += 7;
    };

    function generateModuleHeading(content) {
      var font = { family: 'helvetica', size: { body: 10, title: 12, small: 7.5, heading1: 21, heading2: 16, }, };
      var lineHeight = (fontSize) => 1.4 * fontSize;
      var lineHeightMm = (fontSize) => 1.4 * fontSize * ptToMm;
      var color = { text: 0, line: 0, heading: 255, };
      var ptToMm = 0.352778;
      var margin = { t: 15, r: 195, b: 282, l: 15, }
      var pageW = margin.r - margin.l;
      var profileImage = { w: 30, h: 45, x: margin.t, y: margin.l, }
      var padding = 2;
      var textW = 0;
      var tableSpacing = 5;

      textW = doc.getTextDimensions(content).w * ptToMm;
      doc.setFillColor(headingFill.r, headingFill.g, headingFill.b);
      doc.rect(margin.l, cursor += 3 + tableSpacing, pageW, padding + lineHeightMm(font.size.body), "DF");
      doc.setFontType("bold");
      doc.setTextColor(color.heading);

      doc.text(
        content,
        pageW / 2 + margin.l,
        cursor += lineHeightMm(font.size.body),
        "center"
      );
    };

    function generateDoNotPrintStamp() {
      //console.log('generating do not print stamp');
      var margin = { t: 15, r: 195, b: 282, l: 15, }
      var pageW = margin.r - margin.l;
      doc.setFontSize(24);
      doc.setFontType("bold");
      doc.setTextColor("#bebebe");
      doc.text(
        'Please do not print',
        pageW / 2 + margin.l,
        11,
        "center"
      );
    };
  });
}



// WEBPACK FOOTER //
// ./src/helpers.js